import { getContactMatchesJobs } from "@endpoints/recruiter.service";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import dayjs from "@lib/dayjs";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { NavLink } from "react-router-dom";

const MatchedJobCard = ({ job, member }) => {
  return (
    <NavLink
      to={`/matched-job-details/${member?.candidateId}`}
      state={{
        member,
        jobData: job,
      }}
      className="grid grid-cols-[0.5fr_1fr_0.2fr] gap-10 border-b py-4 items-center hover:bg-gray-50 cursor-pointer"
    >
      <div className="flex flex-col gap-1">
        <span className="font-medium text-charcoal text-xs">{job?.refNo}</span>
        <span className="font-semibold text-charcoal text-xs line-clamp-1">
          {job?.jobTitle}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <span className="font-medium text-xs text-light-black">
          {dayjs().format("hh:mma DD MMM YY")}
        </span>
        <div className="text-xs font-medium text-charcoal bg-light-white-700 rounded-md p-3.5 leading-5">
          <span className="font-bold text-xs">Joe Bloggs</span>
          &nbsp;&nbsp; accepted your invitation and is now part of your network.
        </div>
      </div>
      <div className="mt-6 relative">
        <AnimatedCircleProgress progress={79} />
      </div>
      {/* <div className="font-medium text-light-black text-sm border rounded-full h-12 w-12 flex items-center justify-center">
        79
      </div> */}
    </NavLink>
  );
};

const MatchedJobs = () => {
  const location = useLocation();
  const member = location?.state?.member || location?.state;
  const id = member?.candidateId;

  const [isLoading, setIsLoading] = useState(true);
  const [matchedJobs, setMatchedJobs] = useState([]);

  const getMatchesJobs = async (currentPage = 1) => {
    try {
      const { success, data } = await getContactMatchesJobs(
        id,
        currentPage,
        100
      );
      if (success) {
        setMatchedJobs(data);
      }
    } catch (error) {
      enqueueSnackbar("Oops! Something went wrong!", { variant: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getMatchesJobs();
  }, []);
  return (
    <div className="flex flex-col flex-1 min-h-0 px-5">
      {/* Search section */}
      <div className="flex items-center justify-between border-b pb-4">
        <div className="flex items-center gap-2">
          <div className="bg-light-white-700 rounded-md p-1.5 w-72">
            <input
              className="bg-white rounded-md text-xs h-7 px-3 font-medium w-full outline-none"
              placeholder="Search"
            />
          </div>
          <button className="bg-light-white-700 h-10 px-12 text-xs rounded-md flex items-center justify-center font-bold text-charcoal hover:bg-gray-100">
            Filter
          </button>
        </div>
        <span className="font-medium text-xs text-light-black self-end mr-3">
          Skills match%
        </span>
      </div>
      <div className="flex flex-col min-h-0 overflow-y-scroll no-scrollbar">
        {matchedJobs?.map((job) => {
          return <MatchedJobCard key={job?._id} job={job} member={member} />;
        })}
      </div>
    </div>
  );
};

export default MatchedJobs;
